import { useEffect } from "react";
import {useLocation} from 'react-router-dom';

export default function Seo({ title, description }) {
  const {pathname}=useLocation();
  useEffect(() => {
    document.title = title;
    const set = (sel, val) => {
      const el = document.head.querySelector(sel);
      if (el) el.setAttribute("content", val);
    };
    set('meta[name="description"]', description);
    set('meta[property="og:title"]', title);
    set('meta[property="og:description"]', description);
    set('meta[property="og:url"]','https://merugotradex.in'+pathname);
    const canonical=document.head.querySelector('link[rel="canonical"]');
    if(canonical)canonical.setAttribute('href','https://merugotradex.in'+pathname);
  }, [title, description,pathname]);
  return null;
}
